import React, { useState } from "react";
import { StrasseSAModel } from "../../../api";
import { AutoComplete } from "primereact/autocomplete";

import { MitgliedschaftKontaktEditingAreaEnum } from "../enum/MitgliedschaftViewStatsEnums";
import { statistikAustriaService } from "../service/StatistikAustriaService";
import { LaenderSelect } from "../form/Selects";
import { unchangedMessage } from "../view/KontaktdatenMessages";
import { getDescriptionNameByAuthenticatedRole } from "../service/UserService";
import { PropsKontaktdatenZusendeadresseView } from "../model/PropsInterfaces";

export default function KontaktdatenZusendeadresseView(props: PropsKontaktdatenZusendeadresseView) {
  const [strassenQuery, setStrassenQuery] = useState<string>();
  const [strassenDaten, setStrassenDaten] = useState<Array<StrasseSAModel>>();

  const searchStreet = (event: { query: string }) => {
    statistikAustriaService
      .getStatistikAustriaStrassen(event.query)
      .then((data) => {
        setStrassenDaten(data.data);
      })
      .catch(() => {
        props.setShowError(true);
      });
  };

  const adressSearchTemplate = (item: StrasseSAModel) => {
    return (
      <div className="adress-item">
        <div>
          {item.strassenname} [{item.postleitzahl}&nbsp;{item.ortschaft}]
        </div>
      </div>
    );
  };

  return (
    <>
      <form autoComplete="no">
        {(props.isPersonenbetreuerView && (
          <>
            <p className="infotitle">Zusendeadresse</p>
            <p>
              Sie können eine Änderung der Zusendeadresse für das Mitglied beantragen, indem Sie die Adressdaten
              ausfüllen.
            </p>
          </>
        )) || <p>{getDescriptionNameByAuthenticatedRole(props.userInfo)}</p>}
        <div className="input-group" style={{ display: "flex" }}>
          <div className={"element-input col-12 mb-3"}>
            <div className={"element-staat"}>
              <LaenderSelect
                data={props.laenderdaten}
                value={props.kontaktdatenChanged?.staat || "AT"}
                onChangeHandler={(e: any) => {
                  let newValue = e.currentTarget.value;
                  props.updateKontaktdatenChanged("staat", newValue);
                  if (newValue !== "AT") {
                    props.setManuelleEingabe(true);
                    setStrassenQuery(undefined);
                  }
                }}
                style={{ width: "99%" }}
              ></LaenderSelect>
            </div>
          </div>
        </div>
        <div className="input-group" style={{ display: "flex" }}>
          <div className={"element-input col-10 mb-3"}>
            <AutoComplete
              value={strassenQuery}
              suggestions={strassenDaten}
              completeMethod={searchStreet}
              field="strassenname"
              itemTemplate={adressSearchTemplate}
              dropdown
              onChange={(e) => {
                if (e.value) {
                  if (typeof e.value === "string") {
                    setStrassenQuery(e.value);
                  } else {
                    var street: StrasseSAModel = e.value;
                    let newKontaktdaten = { ...props.kontaktdatenChanged };
                    newKontaktdaten.strasse = street.strassenname;
                    newKontaktdaten.plz = street.postleitzahl;
                    newKontaktdaten.ort = street.gemeinde;
                    newKontaktdaten.strasseSA = street.kennziffer;
                    props.setKontaktdatenChanged(newKontaktdaten);
                    props.validateValues(MitgliedschaftKontaktEditingAreaEnum.ADDRESS, newKontaktdaten);
                  }
                }
              }}
              aria-label="Adresse"
              placeholder={
                props.kontaktdatenChanged?.staat !== "AT"
                  ? "Die Straßensuche ist nur innerhalb von Österreich möglich"
                  : props.manuelleEingabe
                  ? "Manuelle Eingabe aktiviert"
                  : "Suchen Sie hier Ihre Straße (Straße, Ort, PLZ) und wählen Sie diese aus"
              }
              dropdownAriaLabel="Wählen Sie eine Adresse aus"
              autoComplete="no"
              style={{ width: "99%" }}
              disabled={props.manuelleEingabe}
            />
          </div>
          <div className={"element-input col-2 mb-3"}>
            <div className={"element-manuelle-eingabe"}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="manuelle-eingabe"
                  checked={props.manuelleEingabe}
                  onChange={(e) => props.setManuelleEingabe(e.currentTarget.checked)}
                  disabled={props.kontaktdatenChanged?.staat !== "AT"}
                />
                <label className="form-check-label" htmlFor="manuelle-eingabe">
                  manuelle Eingabe
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="input-group" style={{ display: "flex" }}>
          {props.inputField("input_strasse", "strasse", "Straße", "col-7", !props.manuelleEingabe)}
          {props.inputField("input_hausnummer", "hausnummer", "Hausnummer (nur Nummer)", "col-2")}
          {props.inputField("input_zusatz", "zusatz", "Zusatz (z.B.: B/2/4)", "col-3")}
          {props.inputField("input_plz", "plz", "PLZ", "col-4", !props.manuelleEingabe)}
          {props.inputField("input_ort", "ort", "Ort", "col-8", !props.manuelleEingabe)}
        </div>
        {props.buttonGroup(MitgliedschaftKontaktEditingAreaEnum.ADDRESS)}
        {props.showUnchangedMessage && unchangedMessage}
      </form>
    </>
  );
}
